import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import VueMask from 'v-mask';
import store from './store';
import App from './App.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(VueMask);

// init app
console.log('[beltone] main.min.js executed');

const appElements = document.querySelectorAll('[id="beltoneApps"]');

console.log('[beltone] appElements found:', appElements.length);
appElements.forEach((el) => {
	new Vue({
		store,
		render: h => h(App, {
			props: {
				page: el.getAttribute('page'),
				clinicId: el.getAttribute('clinic-id') || null,
				dealerId: el.getAttribute('dealer-id') || null,
				showMap: el.getAttribute('show-map') || 'false',
			},
		}),
	}).$mount(el);
});